import { IconTriangleCaution } from '@endurancewarranty/icons';
import { Flex, Text } from '@endurancewarranty/ui';

import type { FC } from 'react';

export const Error: FC = () => {
  return (
    <Flex className="h-96 w-full" items="center" justify="center" direction="col">
      <IconTriangleCaution className="text-error" width={64} height={64} />
      <Text.Header size="md" margin="my-4" align="center">
        Something went wrong! <br /> Please refresh the browser.
      </Text.Header>
    </Flex>
  );
};
